var exports = {
  "kL": "KeybindsTab.module__container___XzgxSE",
  "ft": "KeybindsTab.module__containerCompact___XzgxSE",
  "Pc": "KeybindsTab.module__searchRow___XzgxSE",
  "Vw": "KeybindsTab.module__customSection___XzgxSE",
  "P_": "KeybindsTab.module__customHeader___XzgxSE",
  "yy": "KeybindsTab.module__customHeaderText___XzgxSE",
  "_U": "KeybindsTab.module__customTitle___XzgxSE",
  "Mu": "KeybindsTab.module__customSubtitle___XzgxSE",
  "DK": "KeybindsTab.module__shortcutOptions___XzgxSE",
  "sC": "KeybindsTab.module__shortcutOption___XzgxSE",
  "wm": "KeybindsTab.module__customList___XzgxSE",
  "Kl": "KeybindsTab.module__customRow___XzgxSE",
  "YI": "KeybindsTab.module__customRowDisabled___XzgxSE",
  "Of": "KeybindsTab.module__customHeaderActions___XzgxSE",
  "DN": "KeybindsTab.module__dotsButton___XzgxSE",
  "D2": "KeybindsTab.module__customRowMain___XzgxSE",
  "EG": "KeybindsTab.module__customField___XzgxSE",
  "gF": "KeybindsTab.module__customFieldLabel___XzgxSE",
  "Ou": "KeybindsTab.module__customControls___XzgxSE",
  "dD": "KeybindsTab.module__customHint___XzgxSE",
  "p$": "KeybindsTab.module__emptyState___XzgxSE",
  "Z8": "KeybindsTab.module__conflictWarning___XzgxSE",
  "se": "KeybindsTab.module__conflictIcon___XzgxSE",
  "rs": "KeybindsTab.module__defaultsList___XzgxSE",
  "WX": "KeybindsTab.module__defaultsSection___XzgxSE",
  "Mz": "KeybindsTab.module__defaultsSectionTitle___XzgxSE",
  "DC": "KeybindsTab.module__defaultsSectionRows___XzgxSE",
  "Bq": "KeybindsTab.module__defaultChipsMerged___XzgxSE",
  "r1": "KeybindsTab.module__defaultChips___XzgxSE",
  "_R": "KeybindsTab.module__defaultRow___XzgxSE",
  "pc": "KeybindsTab.module__defaultRowActions___XzgxSE",
  "AB": "KeybindsTab.module__defaultLabel___XzgxSE",
  "q3": "KeybindsTab.module__defaultChipsEmpty___XzgxSE",
  "Oo": "KeybindsTab.module__defaultChip___XzgxSE",
  "V": "KeybindsTab.module__permissionSectionHelper___XzgxSE",
  "FG": "KeybindsTab.module__systemShortcutsCommands___XzgxSE",
};

module.exports = exports;
